module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso1_tablet.dd976fd8.png";